import { createQueryParams } from '../utils/utils'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQueryList } from '@percent/partner-dashboard/common/hooks'
import { TableColumnSortDirection } from '@percent/lemonade'

export function useMyTasks(direction: TableColumnSortDirection) {
  const { grantsService } = useServices()

  const [
    { data: tasks, isLoading: isLoadingTasks, totalResults: totalTasks },
    { nextPage: nextPageTasks, previousPage: previousPageTasks, refresh: refreshTasks, query: queryTasks }
  ] = useQueryList(grantsService.getMyTasksV2, createQueryParams(direction))

  return {
    tasks,
    isLoading: isLoadingTasks,
    totalTasks,
    nextPage: nextPageTasks,
    previousPage: previousPageTasks,
    refresh: refreshTasks,
    query: queryTasks
  }
}
